import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { SERVICES } from "../../lib/data/services";
import { CITIES } from "../../lib/data/cities";
import { PHONE, PHONE_HREF, EMAIL, EMAIL_HREF } from "./Nav";

export default function Footer() {
  const topCities = CITIES.slice(0, 12);
  const topServices = SERVICES.slice(0, 8);
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#060913] text-[#F4F4F0] pt-24 pb-10 border-t border-white/10"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-4">
              <div className="font-display text-4xl md:text-5xl leading-none w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-[#D92323] text-[#F4F4F0]">
                M
              </div>
              <div className="font-display text-2xl md:text-3xl tracking-tight leading-[0.95]">
                MAZE SECURITY
                <br />
                <span className="text-[#D92323]">SOLUTIONS</span>
              </div>
            </div>
            <div className="mt-4 font-mono text-[10px] tracking-[0.24em] uppercase text-[#F4F4F0]/60">
              British Columbia Security Services
            </div>
            <p className="mt-6 text-[#F4F4F0]/70 text-sm leading-relaxed max-w-sm">
              Province-wide security operations for construction, mining, marine,
              cannabis, corporate, retail, event, and residential clients across
              British Columbia. Licensed, bonded, and insured.
            </p>

            <div className="mt-8 space-y-3">
              <a
                href={PHONE_HREF}
                data-testid="footer-phone"
                className="inline-flex items-center gap-3 font-mono text-sm tracking-[0.14em] hover:text-[#D92323] transition-colors"
              >
                <Phone size={16} strokeWidth={1.5} className="text-[#D92323]" />
                {PHONE}
              </a>
              <br />
              <a
                href={EMAIL_HREF}
                data-testid="footer-email"
                className="inline-flex items-center gap-3 font-mono text-sm tracking-[0.1em] hover:text-[#D92323] transition-colors"
              >
                <Mail size={16} strokeWidth={1.5} className="text-[#D92323]" />
                {EMAIL}
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#D92323] mb-4">
              Services
            </div>
            <ul className="space-y-2">
              {topServices.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-[#F4F4F0]/80 hover:text-white text-sm"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/services" className="text-[#D92323] text-sm font-mono">
                  All Services →
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#D92323] mb-4">
              Cities
            </div>
            <ul className="space-y-2 grid grid-cols-2 gap-x-2">
              {topCities.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/cities/${c.slug}`}
                    className="text-[#F4F4F0]/80 hover:text-white text-sm"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
            <Link to="/cities" className="mt-3 inline-block text-[#D92323] text-sm font-mono">
              All 50+ Cities →
            </Link>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#D92323] mb-4">
              Company
            </div>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-[#F4F4F0]/80 hover:text-white text-sm">About</Link></li>
              <li><Link to="/regions" className="text-[#F4F4F0]/80 hover:text-white text-sm">Regions</Link></li>
              <li><Link to="/blog" className="text-[#F4F4F0]/80 hover:text-white text-sm">Journal</Link></li>
              <li><Link to="/contact" className="text-[#F4F4F0]/80 hover:text-white text-sm">Contact</Link></li>
              <li><Link to="/sitemap" className="text-[#F4F4F0]/80 hover:text-white text-sm">Sitemap</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[#F4F4F0]/60">
            © {new Date().getFullYear()} Maze Security Solutions · Serving all of BC
          </div>
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[#F4F4F0]/60">
            Licensed · Bonded · Insured
          </div>
        </div>
      </div>
    </footer>
  );
}
